import dotProp from 'dot-prop-immutable'
import {
  ALLOW_TO_RESIZE,
  DISALLOW_TO_RESIZE,
  FINISH_RESIZING_FRAME,
  RESIZE_FRAME,
  SELECT_FRAME,
} from '../../constants/projectActions'
import getProducts from '../../repositories/getProducts'
import matchFrameToResize from '../../utils/matchFrameToResize'
import perMeterCalc from '../../utils/perMeterCalc'
import { finishResize, startResize } from '../products'
import { toggleNavigationProducts } from '../sidebar'

export const disallowToResize = () => ({ type: DISALLOW_TO_RESIZE })

export const allowToResize = () => ({ type: ALLOW_TO_RESIZE })

export const toggleToResize = () => (dispatch, ownState) => {
  const frames = dotProp.get(ownState(), 'products.images', [])
  if (frames.length === 0) {
    dispatch(toggleNavigationProducts(getProducts(window.fetch)))
  }

  dotProp.get(ownState(), 'project.allowToResize', false) ? dispatch(disallowToResize()) : dispatch(allowToResize())
}
export const resizeFrame = (index, { deltaX, deltaY }, isFinish = true, pos) => (dispatch, ownState) => {
  dispatch({ type: SELECT_FRAME, index })

  const perMeter = dotProp.get(ownState(), 'project.background.perMeter')
  const frames = dotProp.get(ownState(), 'products.images', [])
  if (frames.length === 0) {
    dispatch(toggleNavigationProducts(getProducts(window.fetch)))
  }

  try {
    // const originalPosition = getOriginalPosition(ownState(), index)

    const originalSize = getOriginalSize(ownState(), deltaX, deltaY, index)
    const originalCrop = getOriginalCrop(ownState(), index)

    const newSize = matchFrameToResize(
      {
        originalW: originalSize.width,
        originalH: originalSize.height,
      },
      { deltaX: deltaX, deltaY: deltaY },
      frames,
      perMeter
    )

    dispatch({ type: RESIZE_FRAME, index, width: deltaX, height: deltaY, crop: originalCrop })
    dispatch({ type: FINISH_RESIZING_FRAME, index, width: newSize.w, height: newSize.h })

    if (isFinish) {
      const width = perMeterCalc(newSize.w, perMeter)
      const height = perMeterCalc(newSize.h, perMeter)

      dispatch({ type: RESIZE_FRAME, index, width, height, resized: true, crop: defaultCrop() })
      dispatch(finishResize())
    } else {
      dispatch(startResize(index))
    }



  } catch (e) {
    dispatch({ type: RESIZE_FRAME, index, deltaX, deltaY })
    dispatch(finishResize())
  }
}

function getOriginalSize(state, width, height, index) {
  return dotProp.get(state, `project.pictures.${index}`, { width, height })
}

function getOriginalCrop(state, index) {
  return dotProp.get(state, `project.pictures.${index}.crop`)
}

function getOriginalPosition(state, index) {
  return dotProp.get(state, `project.pictures.${index}.position`, {x: 0, y: 0})
}

const defaultCrop = () => ({ x: 0, y: 0, width: 0, height: 0 })



// WEBPACK FOOTER //
// ./src/actions/project/resizable.js